import Splide, { ResponsiveOptions } from '@splidejs/splide';
import CMSHelper from '../../helpers/cms-helper';

const selectors = {
  container: '.js-categoryCarousel',
  items: '.js-items',
  nextButton: '.js-next',
  previousButton: '.js-prev',
  slide: '.splide__slide',
  slideVisible: '.is-visible',
};

export default class CategoryCarousel {
  private readonly itemsContainer: HTMLElement;
  private readonly numSlides: number;

  constructor(container: HTMLElement) {
    this.itemsContainer = container.querySelector(selectors.items) as HTMLElement;
    this.numSlides = this.itemsContainer.querySelectorAll(selectors.slide).length;
    const nextButton = container.querySelector<HTMLButtonElement>(selectors.nextButton) as HTMLButtonElement;
    const prevButton = container.querySelector<HTMLButtonElement>(selectors.previousButton) as HTMLButtonElement;

    const isHalfWidthComponent = CMSHelper.isHalfWidthComponent(container);

    let breakpoints: Record<string | number, ResponsiveOptions>;
    let perPage: number;
    if (isHalfWidthComponent) {
      perPage = 1;
      breakpoints = {};
    } else {
      perPage = 4;
      breakpoints = {
        1024: {
          perPage: 1,
        },
      };
    }

    const slider = new Splide(this.itemsContainer, {
      perPage,
      breakpoints,
      type: 'loop',
      perMove: 1,
      gap: 60,
      arrows: false,
      pagination: false,
      autoplay: !this.isStatic(),
      interval: 5000,
    });

    slider.on('resize', () => {
      const isStatic = this.isStatic();
      container.classList.toggle('-hide-buttons', isStatic);
      if (isStatic) {
        slider.Components.Autoplay.pause();
        slider.go(1);
      } else {
        slider.Components.Autoplay.play();
      }
    });

    slider.mount();

    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      slider.go('<');
    });

    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      slider.go('>');
    });

    container.classList.remove(selectors.container.slice(1));
  }

  private isStatic(): boolean {
    const visibleSlides = this.itemsContainer.querySelectorAll(selectors.slideVisible).length;
    return visibleSlides === this.numSlides;
  }

  static initAll(): CategoryCarousel[] {
    return Array.from(document.querySelectorAll<HTMLElement>(selectors.container))
      .map((element) => new CategoryCarousel(element));
  }
}
